module.exports = __webpack_public_path__ + "img/Success-icon.d187632c.png";